import React from "react";
import { AgentExecutionResult, AgentJob } from "../types";
import {
  FakeBadge,
  JobCard,
  JobCardHeader,
  JobCardMeta,
  JobCardOutput,
} from "../styles";
import { formatNeuralTime } from "../utils/routes";

type Props = { job: AgentJob; result?: AgentExecutionResult };

export const AgentJobCard: React.FC<Props> = ({ job, result }) => (
  <JobCard aria-label={`${job.execution_mode === "FAKE" ? "fake" : "Codex read-only"} AgentJob`}>
    <JobCardHeader>
      <strong>{job.title}</strong>
      <FakeBadge>{job.execution_mode === "FAKE" ? "시뮬레이션 · 실행 안 함" : "읽기 전용 · 외부 작업 없음"}</FakeBadge>
    </JobCardHeader>
    <JobCardMeta>
      <span>담당: {job.target_agent.display_name}</span>
      <span>유형: {job.request_type}</span>
      <span>상태: 접수됨</span>
      <time dateTime={job.created_at}>{formatNeuralTime(job.created_at)}</time>
    </JobCardMeta>
    <JobCardOutput>기대 결과: {job.expected_output}</JobCardOutput>
    {result && <JobCardOutput>
      <strong>{result.result.requires_ceo_review ? "대표 검토 필요" : "Agent 결과"}</strong>
      <span>{result.result.summary}</span>
      {result.result.questions.length > 0 && <span>질문: {result.result.questions.join(" · ")}</span>}
      {result.result.risks.length > 0 && <span>위험: {result.result.risks.join(" · ")}</span>}
    </JobCardOutput>}
  </JobCard>
);
